<template>
	<div>
		<vs-table stripe noDataText="گارانتی موجود نیست." :data="warrantiesList">

			<template slot="header">
				<vs-button @click="addWarranty()" class="mb-4">ثبت گارانتی جدید</vs-button>
				<!-- <div @keydown.enter="search()">
					<vs-input class="w-full searchInput mb-4" v-model="title" placeholder="جستجو..." />
				</div> -->
			</template>

			<template slot="thead">
				<vs-th>	نام خریدار </vs-th>
				<vs-th>	شماره گارانتی </vs-th>
				<vs-th>	نوع سیستم </vs-th>
				<vs-th>	تاریخ شروع گارانتی </vs-th>
				<vs-th>  </vs-th>
			</template>

			<template slot-scope="{data}">
				<vs-tr :key="indextr" v-for="(tr, indextr) in data" >
					<vs-td>
						{{data[indextr].customer}}
					</vs-td>

					<vs-td>
						{{data[indextr].number}}
					</vs-td>

					<vs-td>
						{{data[indextr].system_type}}
					</vs-td>

					<vs-td>
						{{startDate(data[indextr].start_date)}}
					</vs-td>
					<vs-td class="">
						<feather-icon @click="editWarranty(data[indextr].id)" icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="mr-4 button-link" />
						<feather-icon @click="deleteWarranty(data[indextr].number, data[indextr].customer, data[indextr].id)" icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="button-link" />
            		</vs-td>
				</vs-tr>
				<div class="float-left">
					<vs-pagination class="mt-4" :total="last_page" v-model="table_options.current_page"></vs-pagination>
				</div>
			</template>

		</vs-table>

		<AddWarranty :popupAddWarranty='popupAddWarranty' @updatePopupAddWarranty='updatePopupAddWarranty'/>

		<EditWarranty :popupEditWarranty='popupEditWarranty' :warrantyId='editWarrantyId' @updatePopupEditWarranty='updatePopupEditWarranty'/>

		<DeleteWarranty :popupDeleteWarranty='popupDeleteWarranty' :warrantyId='deleteWarrantyId' :number='warrantyNumber' :customer='warrantyCostomer' @updatePopupDeleteWarranty='updatePopupDeleteWarranty'/>

	</div>
</template>

<script>
import AddWarranty from './Add'
import EditWarranty from './Edit'
import DeleteWarranty from './Delete'

export default {
	components: {
		AddWarranty,
		EditWarranty,
		DeleteWarranty,
	},

	data() {
		return{
			popupAddWarranty: false,
			popupEditWarranty: false,
			popupDeleteWarranty: false,

			editWarrantyId: 0,
			deleteWarrantyId: 0,

			warrantyNumber: '',
			warrantyCostomer: '',

      last_page: 0,
			table_options: {
				current_page: 1,
			},
		}
	},

	computed: {
		warrantiesList() {
      return this.$store.state.warranties.warranties
		},
	},

	watch: {
		"table_options.current_page": function () {
			this.getWarranties();
		},
	},

	created(){
		this.getWarranties();
	},

	methods: {
		startDate(date){
			if (date === null) {
				return "0000/00/00";
			} else {
				return date.replace(/-/g, "/");
			}
		},

    getWarranties(){
			this.$vs.loading()
			let data = {
				page: this.table_options.current_page
			}
			this.$store.dispatch('getwarranties', data)
			.then((res) => {
				this.last_page = res.data.last_page;
				this.$vs.loading.close()
			}).catch(() => {
				this.$vs.loading.close()
				this.$vs.notify({
					title: '',
					text: 'خطا در اتصال به اینترنت',
					iconPack: 'feather',
					icon: 'icon-alert-circle',
					color: 'warning'
				})
			})
		},

		addWarranty(){
			this.popupAddWarranty = true
		},

		editWarranty(id){
			this.popupEditWarranty = true
			this.editWarrantyId = id
		},

		deleteWarranty(number, customer, id){
			this.popupDeleteWarranty = true
			this.warrantyNumber = number
			this.warrantyCostomer = customer
			this.deleteWarrantyId = id
		},

    updatePopupAddWarranty(value){
      this.popupAddWarranty = value
		},

		updatePopupEditWarranty(value){
      this.popupEditWarranty = value
		},

		updatePopupDeleteWarranty(value){
      this.popupDeleteWarranty = value
    },
  }
}
</script>

<style>
.center {
    padding: 2.2rem !important;
}
.button-link {
	cursor: pointer;
}
.vs-con-table .vs-con-tbody {
    border: unset !important;
}
</style>
